/**
 * Canonical acquisition overall_status → sales-evaluation bucket contract.
 * Must stay aligned with BE App\Support\CrmAcquisitionStatusContract.
 *
 * RUNNING: open only (unknown closed_* never falls into running).
 * SUCCESS: closed_accepted | closed_successful | closed_success
 * FAILED: closed_rejected | closed_unsuccessful | closed_failed
 */

export const ACQUISITION_STATUS_RUNNING = Object.freeze(['open']);

export const ACQUISITION_STATUS_SUCCESS = Object.freeze([
  'closed_accepted',
  'closed_successful',
  'closed_success',
]);

export const ACQUISITION_STATUS_FAILED = Object.freeze([
  'closed_rejected',
  'closed_unsuccessful',
  'closed_failed',
]);

export const ACQUISITION_STATUS_BUCKETS = Object.freeze({
  running: ACQUISITION_STATUS_RUNNING,
  success: ACQUISITION_STATUS_SUCCESS,
  failed: ACQUISITION_STATUS_FAILED,
});

export function acquisitionOverallStatusFilterParam(bucket) {
  const codes = ACQUISITION_STATUS_BUCKETS[bucket];
  return Array.isArray(codes) ? codes.join(',') : '';
}

/**
 * Click filters for Stav akvizícií chart segments (order: failed, running, success).
 * Raw overall_status codes only — never translated labels.
 */
export function buildAcquisitionStatusClickFilters() {
  return [
    { request: { filter_overall_status: acquisitionOverallStatusFilterParam('failed') } },
    { request: { filter_overall_status: acquisitionOverallStatusFilterParam('running') } },
    { request: { filter_overall_status: acquisitionOverallStatusFilterParam('success') } },
  ];
}

export function classifyAcquisitionOverallStatus(overallStatus) {
  const overall = String(overallStatus ?? '').trim().toLowerCase();
  if (overall === '' || ACQUISITION_STATUS_RUNNING.includes(overall)) return 'running';
  if (ACQUISITION_STATUS_SUCCESS.includes(overall)) return 'success';
  if (ACQUISITION_STATUS_FAILED.includes(overall)) return 'failed';
  return null;
}
